module.exports = __webpack_public_path__ + "static/img/1.3097885d.png";